import { defineComponent as _defineComponent } from 'vue'
import SvgIcon from './SvgIcon.vue';
import ArrowUp from '../icons/ArrowUpIcon.vue';
import { IconButtonLayout } from '../../../constants/room';
import { computed } from 'vue';
import { isMobile } from '../../../utils/environment';
import UnSupportIcon from '../icons/UnSupportIcon.vue';
import '../../../directives/vTap';
import type { Component } from 'vue';

interface Props {
  title?: string;
  hasMore?: boolean;
  hideHoverEffect?: boolean;
  disabled?: boolean;
  isActive?: boolean;
  layout?: IconButtonLayout;
  icon?: Component | null;
  isNotSupport?: boolean;
  theme?: 'white' | 'black';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    title: { default: '' },
    hasMore: { type: Boolean, default: false },
    hideHoverEffect: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
    layout: { default: IconButtonLayout.VERTICAl },
    icon: { default: null },
    isNotSupport: { type: Boolean, default: false },
    theme: { default: undefined }
  },
  emits: ['click-icon', 'click-more'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, hasMore: boolean, hideHoverEffect: boolean, disabled: boolean, isActive: boolean, layout: IconButtonLayout, icon: Component | null, isNotSupport: boolean, theme: 'white' | 'black' };




const themeClass = computed(() =>
  props.theme ? `tui-theme-${props.theme}` : ''
);

const iconContentClass = computed(() => {
  if (props.layout === IconButtonLayout.HORIZONTAL) {
    return 'icon-content-horizontal';
  }
  return 'icon-content-vertical';
});

const handleClickEvent = () => {
  emit('click-icon');
};

return { __sfc: true,props, emit, themeClass, iconContentClass, handleClickEvent, SvgIcon, ArrowUp, isMobile, UnSupportIcon }
}

})